(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["algolia-instore-pickup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const pickupToggle = document.getElementById('in-store-pickup-toggle');
    const storesToggle = document.getElementById('search-in-store-pickup-stores-toggle');
    const storesContainer = document.getElementById('search-in-store-pickup-stores');
    const storeAddressContainers = document.querySelectorAll('#search-in-store-pickup-stores details');
    if (!pickupToggle) return;
    if (pickupToggle.checked) {
      document.body.classList.remove('in-store-pickup-inactive');
    } else {
      document.body.classList.add('in-store-pickup-inactive');
    }
    pickupToggle.addEventListener('change', function () {
      if (pickupToggle.checked) {
        document.body.classList.remove('in-store-pickup-inactive');
      } else {
        document.body.classList.add('in-store-pickup-inactive');
        storeAddressContainers.forEach((element) => element.removeAttribute('open'));
      }
    });
    storesToggle.addEventListener('click', () => {
      storeAddressContainers.forEach((element) => element.removeAttribute('open'));
      storesContainer.classList.toggle('open');
      if (storesContainer.classList.contains('open')) {
        storesToggle.innerText = 'Collapse';
        storesToggle.setAttribute('aria-label', 'Collapse');
      } else {
        storesToggle.innerText = 'Change store';
        storesToggle.setAttribute('aria-label', 'Change store');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-swatches"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const productSwatches = document.querySelectorAll('.product-swatch');
    productSwatches.forEach((swatch) => {
      swatch.addEventListener('click', function () {
        productSwatches.forEach((s) => {
          if (s.dataset.option === this.dataset.option) s.classList.remove('selected');
        });
        this.classList.add('selected');
        updateSelectedVariant();
      });
    });
    updateSelectedVariant(); // initial update to set correct states on page load
  });

  const updateSelectedVariant = (selectedOption1, selectedOption2, selectedOption3) => {
    // ensure product object is available
    if (!product) {
      console.error('Product object not found. Unable update selected variant.');
      return;
    }

    // get currently selected options from swatches
    const productSwatches = document.querySelectorAll('.product-swatch');
    const selectedSwatches = Array.from(productSwatches).filter((s) => s.classList.contains('selected'));
    const selectedOptions = Object.fromEntries(selectedSwatches.map((s) => [s.dataset.option, s.dataset.value]));

    // fallback to currently selected variant options if not provided (e.g. on page load)
    selectedOption1 = selectedOption1 || selectedOptions.option1 || null;
    selectedOption2 = selectedOption2 || selectedOptions.option2 || null;
    selectedOption3 = selectedOption3 || selectedOptions.option3 || null;

    // find the variant that matches the selected options
    const selectedVariant = product.variants.find(
      (v) => v.option1 === selectedOption1 && v.option2 === selectedOption2 && v.option3 === selectedOption3
    );

    // update the product object with the selected variant id for use in other functions (e.g. add to cart)
    product.selected_variant_id = selectedVariant?.id || null;

    // updatate the hidden select to ensure correct variant is added to cart
    const optionSelectors = document.querySelectorAll('.single-option-selector');
    optionSelectors.forEach((selector) => {
      selectedVariant.options.forEach((optionValue, index) => {
        if (selector.id === `product-select-option-${index}`) {
          selector.value = optionValue;
          selector.dispatchEvent(new Event('change')); // trigger change event to update any listeners (e.g. price updates, etc.)
        }
      });
    });
    // document.getElementById('product-select').value = product.selected_variant_id;
    // document.getElementById('product-select').dispatchEvent(new Event('change'));

    // Update URL with selected variant
    const url = new URL(window.location);
    if (product.selected_variant_id) {
      url.searchParams.set('variant', product.selected_variant_id);
    } else {
      url.searchParams.delete('variant');
    }
    window.history.replaceState({}, '', url);

    // determine available options based on selected variant
    const availableVariants = Array.from(product.variants).filter((variant) => variant.available);
    const availableOption1s = new Set(
      availableVariants.filter((v) => v.option2 === selectedOptions.option2).map((v) => v.option1)
    );
    const availableOption2s = new Set(
      availableVariants.filter((v) => v.option1 === selectedOptions.option1).map((v) => v.option2)
    );
    productSwatches.forEach((s) => {
      if (s.dataset.option === 'option1') {
        !availableOption1s.has(s.dataset.value) ? s.classList.add('unavailable') : s.classList.remove('unavailable');
      } else if (s.dataset.option === 'option2') {
        !availableOption2s.has(s.dataset.value) ? s.classList.add('unavailable') : s.classList.remove('unavailable');
      }
    });

  };
  } catch(e) { console.error(e); }
})();

})();
